import myPosts from '@/store/modules/dashboard/my-posts';
import membership from '@/store/modules/dashboard/membership';
import supportMe from '@/store/modules/dashboard/support-me';
import extras from '@/store/modules/dashboard/extras';
import payments from '@/store/modules/dashboard/payments';
import editorPopup from '@/store/modules/dashboard/editorPopup';

export default {
  namespaced: true,
  modules: {
    myPosts,
    membership,
    supportMe,
    extras,
    payments,
    editorPopup,
  },
};
